<div id="chart" #chart>
  @if (displayChart) {
    <canvas
      #chart="base-chart"
      class="multi-var-bar"
      baseChart
      [datasets]="data"
      [options]="options"
      [labels]="labels"
      chartType="bar"
    ></canvas>
  } @else {
    <img [src]="displayImage"/>
    <div #resizeContainer class="resize-container">
      <canvas
        #chart="base-chart"
        class="multi-var-bar"
        baseChart
        [datasets]="data"
        [options]="options"
        [labels]="labels"
        chartType="bar"
      ></canvas>
    </div>
  }
</div>
